import { getMaturaTaskTypeCode3 } from "../maturaTaskClassification";
import React, { useContext } from "react";
import MaturaPdfPreview from "../../components/MaturaPdfPreview";
import { MaturaReviewContext } from "../../components/MaturaExamRunner/MaturaReviewContext";
import anchors from "./maj2026Anchors.json";
import { withTaskSeed } from "../withTaskSeed";
import * as ParityProductProof from "../../generators/dzial10_dowody/temat3_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaParityProductDivisibilityOpenTask";
import * as FactoredRootsSumParameter from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaFactoredRootsSumParameterClosedTask";
import * as LinearRationalEquation from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaLinearRationalEquationClosedTask";
import * as QuadraticInequality from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaQuadraticInequalityOpenTask";
import * as TicketRevenueSystem from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaTicketRevenueSystemOpenTask";
import * as PiecewiseReading from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaPiecewiseReadingOpenTask";
import * as QuadraticShiftFormula from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaQuadraticShiftFormulaOpenTask";
import * as SequenceTask15 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaLinearSequenceGeometricTripletOpenTask";
import * as SequenceTask16 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaArithmeticSymmetricTermClosedTask";
import * as SequenceTask17 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaGeometricEqualIndexSumProductOpenTask";
import * as AreaRatioProof from "../../generators/dzial10_dowody/temat3_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaAngleBisectorAreaRatioProofOpenTask";
import * as Task27 from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaSquarePyramidDiagonalAngleVolumeOpenTask";
import * as Task30 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaTwoDigitSetsDivisibilityProbabilityOpenTask";
import * as Task18 from "../../generators/dzial5_trygonometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_zamkniete_types/MaturaRightTriangleSineClosedTask";
import * as Task19 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCircleInscribedCentralAngleClosedTask";
import * as Task20 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaParallelLinesSegmentsClosedTask";
import * as Task23 from "../../generators/dzial5_trygonometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_zamkniete_types/MaturaTrigTanFromLinearRelationClosedTask";
import * as Task131 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaLinearCoefficientsGraphTruthClosedTask";
import * as Task132 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaLinearSlopeFromGraphClosedTask";
import * as Task241 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCoordinateRightTriangleAreaClosedTask";
import * as Task242 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaRightTriangleCircumcenterCoordinatesClosedTask";
import * as Task25 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCirclePointEquationTruthClosedTask";
import * as Task26 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaParallelLineYAxisIntersectionClosedTask";
import * as Task22 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaEquilateralTriangleCircumradiusOpenTask";
import * as Task28 from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaConeCylinderVolumeRatioClosedTask";
import * as Task29 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaOddThreeDigitCountingClosedTask";
import * as Task31 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaTwoClassStatsTruthClosedTask";
import * as Task32 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCombinedGroupMeanClosedTask";
import * as Task331 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaProjectileGroundTimeClosedTask";
import * as Task332 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaProjectileVertexTimeClosedTask";
import * as Task01 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaSqrtProductPlusPowerClosedTask";
import * as Task02 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaCompoundInterestClosedTask";
import * as Task03 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaNestedRootPowerClosedTask";
import * as Task04 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaLogPropClosedTask";
import * as Task05 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaPowerDivisibilityTruthClosedTask";
import * as Task06 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaBinomialRootValueClosedTask";

export const sheet = {
  id: "cke-p-2026-maj",
  title: "Matura z matematyki 2026 – termin główny",
  subtitle: "Poziom podstawowy, 5 maja 2026",
  sourceLabel: "CKE • Formuła 2023 • MMAP-P0-100-A-2605",
  sessionType: "main",
  taskCount: 33,
  maxPoints: 50,
};

function decorateTask(task) {
  const taskNumber = String(task?.source?.taskNumber ?? "");
  const match = /^(\d+)(?:\.(\d+))?$/.exec(taskNumber);
  if (!match) return task;
  const baseNumber = Number(match[1]);
  if (!match[2]) return { ...task, displayBaseNumber: baseNumber };
  return {
    ...task,
    displayBaseNumber: baseNumber,
    maturaGroupId: match[1],
    maturaGroupPart: Number(match[2]),
  };
}







const taskModulesByNumber = {
  "1": Task01, "2": Task02, "3": Task03, "4": Task04, "5": Task05, "6": Task06,
  "7": ParityProductProof, "8": FactoredRootsSumParameter, "9": LinearRationalEquation,
  "10": QuadraticInequality, "11": TicketRevenueSystem, "12": PiecewiseReading,
  "13.1": Task131, "13.2": Task132, "14": QuadraticShiftFormula,
  "15": SequenceTask15, "16": SequenceTask16, "17": SequenceTask17,
  "18": Task18, "19": Task19, "20": Task20,
  "21": AreaRatioProof, "22": Task22,
  "23": Task23, "24.1": Task241, "24.2": Task242, "25": Task25, "26": Task26,
  "27": Task27, "28": Task28, "29": Task29, "30": Task30, "31": Task31, "32": Task32,
  "33.1": Task331, "33.2": Task332,
};

function getTaskModule(task) {
  const taskNumber = String(task?.source?.taskNumber ?? "");
  const module = taskModulesByNumber[taskNumber];
  if (!module) throw new Error("Unknown Matura 2026 task number: " + taskNumber);
  return module;
}

const generatedTaskFactories = {
  "1": (variant) => Task01.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "2": (variant) => Task02.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "3": (variant) => Task03.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "4": (variant) => Task04.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "5": (variant) => Task05.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "6": (variant) => Task06.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "7": (variant) => ParityProductProof.generateTask({ variant }),
  "8": (variant) => FactoredRootsSumParameter.generateTask({
    variant,
    session: variant === "original" ? "2026_MAJ" : undefined,
  }),
  "9": (variant) => LinearRationalEquation.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "10": (variant) => QuadraticInequality.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "11": (variant) => TicketRevenueSystem.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "12": (variant) => PiecewiseReading.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "13.1": (variant) => Task131.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "13.2": (variant) => Task132.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "14": (variant) => QuadraticShiftFormula.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "15": (variant) => SequenceTask15.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "16": (variant) => SequenceTask16.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "17": (variant) => SequenceTask17.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "18": (variant) => Task18.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "19": (variant) => Task19.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "20": (variant) => Task20.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "21": (variant) => AreaRatioProof.generateTask({
    variant,
    session: variant === "original" ? "2026_MAJ" : undefined,
    proofKind: "areaRatio",
  }),
  "22": (variant)=>Task22.generateTask({variant,session:variant==="original"?"2026_MAJ":undefined}),
  "23": (variant) => Task23.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "24.1": (variant) => Task241.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "24.2": (variant) => Task242.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "25": (variant) => Task25.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "26": (variant) => Task26.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "27": (variant)=>Task27.generateTask({variant,session:variant==="original"?"2026_MAJ":undefined}),
  "28": (variant) => Task28.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "29": (variant) => Task29.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "30": (variant)=>Task30.generateTask({variant,session:variant==="original"?"2026_MAJ":undefined}),
  "31": (variant) => Task31.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "32": (variant) => Task32.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "33.1": (variant) => Task331.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
  "33.2": (variant) => Task332.generateTask({ variant, session: variant === "original" ? "2026_MAJ" : undefined }),
};

const taskBlueprints = [
  ["1", 1, "Liczby i dzialania", "Pierwiastki i potegi", "\\sqrt{\\frac{25}{8}}\\cdot\\sqrt{2}+2^{-1}"],
  ["2", 1, "Procent skladany", "Lokata dwuletnia 10000 zl, oprocentowanie 6% rocznie", null],
  ["3", 1, "Pierwiastki", "Potega liczby z pierwiastkiem", "\\sqrt{5\\sqrt{5}}"],
  ["4", 1, "Logarytmy", "Roznica logarytmow o tej samej podstawie", "\\log_{8}4-\\log_{8}32"],
  ["5", 1, "Potegi i podzielnosc", "Ocena dwoch zdan P/F", "4^{12}\\cdot 5^{24}"],
  ["6", 1, "Wzory skroconego mnozenia", "Wartosc wyrazenia dla x z pierwiastkiem", "x^{2}+10x+25,\\quad x=\\sqrt{2}-5"],
  ["7", 2, "Dowod podzielnosci", "Podzielnosc wyrazenia z liczba calkowita", null],
  ["8", 1, "Rownania wielomianowe", "Parametr w rownaniu iloczynowym", "3(x+3)(x-m)(2x+4)=0"],
  ["9", 1, "Rownania wymierne", "Rozwiazanie rownania wymiernego", "\\frac{x+2}{3x-1}=\\frac{2}{5}"],
  ["10", 2, "Nierownosci kwadratowe", "Rozwiazanie nierownosci kwadratowej", "3x^{2}+4x\\ge 6x+8"],
  ["11", 2, "Uklad rownan", "Zadanie tekstowe o biletach", null],
  ["12", 4, "Funkcja przedzialowa", "Równanie, maksimum, zbiór wartości i nierówność z wykresu", null],
  ["13.1", 1, "Funkcja liniowa", "Znaki wspolczynnikow z wykresu", null],
  ["13.2", 1, "Funkcja liniowa", "Tangens kata nachylenia prostej", "\\tan\\alpha"],
  ["14", 4, "Funkcja kwadratowa", "Przesuniecie wykresu i wzor ogolny", "g(x)=f(x+1)"],
  ["15", 3, "Ciag geometryczny", "Trzy wyrazy ciagu liniowego tworza ciag geometryczny", "a_n=3n+5"],
  ["16", 1, "Ciag arytmetyczny", "Dziewiaty wyraz ciagu", "a_1=1,\\ a_5=17"],
  ["17", 1, "Ciag geometryczny", "Iloczyny wyrazow ciagu geometrycznego", "a_3\\cdot a_6=18"],
  ["18", 1, "Trygonometria", "Sinus kata w trojkacie prostokatnym", null],
  ["19", 1, "Okregi i katy", "Katy wpisane i srodkowe", null],
  ["20", 1, "Podobienstwo trojkatow", "Dlugosc odcinka z twierdzenia Talesa", null],
  ["21", 2, "Planimetria", "Dowod z dwusieczna i stosunkiem pol", null],
  ["22", 1, "Trojkat rownoboczny", "Bok trojkata wpisanego w okrag", "R=9\\sqrt{3}"],
  ["23", 1, "Trygonometria", "Tangens z rownania z sinusem i cosinusem", "\\frac{3\\sin\\alpha+4\\cos\\alpha}{4\\cos\\alpha}=6"],
  ["24.1", 1, "Geometria analityczna", "Pole trojkata z danych wspolrzednych", "A=(0,-3),\\ B=(2,1),\\ C=(0,2)"],
  ["24.2", 1, "Geometria analityczna", "Srodek okregu opisanego na trojkacie prostokatnym", "A=(0,-3),\\ B=(2,1),\\ C=(0,2)"],
  ["25", 1, "Okreg w ukladzie wspolrzednych", "Punkt na okregu i rownanie okregu P/F", "S=(1,-3),\\ r=5"],
  ["26", 1, "Proste rownolegle", "Punkt przeciecia prostej z osia Oy", "y=-\\frac{1}{3}x+2"],
  ["27", 2, "Stereometria", "Objetosc ostroslupa prawidlowego czworokatnego", null],
  ["28", 1, "Stereometria", "Stosunek objetosci stozka i walca", null],
  ["29", 1, "Kombinatoryka", "Liczby trzycyfrowe nieparzyste z podanych cyfr", null],
  ["30", 2, "Prawdopodobienstwo", "Losowanie cyfr i podzielnosc liczby dwucyfrowej", null],
  ["31", 1, "Statystyka", "Srednia i mediana z dwoch diagramow P/F", null],
  ["32", 1, "Srednia arytmetyczna", "Srednia wazona dwoch grup liczb", null],
  ["33.1", 1, "Funkcja kwadratowa w kontekscie", "Czas uderzenia pileczki o ziemie", "h(t)=-4{,}9t^2+14{,}7t"],
  ["33.2", 1, "Funkcja kwadratowa w kontekscie", "Czas osiagniecia najwiekszej wysokosci", "h(t)=-4{,}9t^2+14{,}7t"],
].map(([taskNumber, points, topic, summary, latex]) => ({ taskNumber, points, topic, summary, latex }));

const pointsByTaskNumber = Object.fromEntries(taskBlueprints.map((item) => [item.taskNumber, item.points]));

export function generateTasks(variant = "original") {
  return generatePagedTasks(variant).map(row => row.task);
}

export function generateTaskVariant(taskNumber, variant = "random", options = {}) {
  const normalizedTaskNumber = String(taskNumber);
  const blueprintIndex = taskBlueprints.findIndex((item) => item.taskNumber === normalizedTaskNumber);
  const blueprint = taskBlueprints[blueprintIndex];
  if (!blueprint) return null;

  const factory = generatedTaskFactories[normalizedTaskNumber];
  const group = normalizedTaskNumber.split(".")[0];
  const siblings = taskBlueprints.filter(row => row.taskNumber.split(".")[0] === group);
  const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
  if (siblings.length > 1 && !options.single) {
    const linkedTasks = siblings.map(row => generateTaskVariant(row.taskNumber, variant, { ...options, seed, single: true }));
    return { ...linkedTasks.find(row => row.meta.taskNo === normalizedTaskNumber), linkedTasks };
  }
  const generated = variant === "original" ? factory?.(variant) : withTaskSeed(`${seed}:${group}`, () => factory?.(variant));
  if (!generated) {
    throw new Error("Missing Matura 2026 generator for task " + normalizedTaskNumber);
  }
  const normalizedGenerated = generated && {
    ...generated,
    source: {
      ...(generated.source || {}),
      variant,
      exam: "MATURA",
      session: "2026_MAJ",
      taskNumber: normalizedTaskNumber,
    },
  };
  const task = decorateTask(normalizedGenerated);
  return {
    index: blueprintIndex,
    task,
    meta: {
      taskNo: normalizedTaskNumber,
      code3: getMaturaTaskTypeCode3(task),
      maxPoints: pointsByTaskNumber[normalizedTaskNumber] || 1,
    },
  };
}

export function generatePagedTasks(variant = "original", options = {}) {
  const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
  return taskBlueprints.map((blueprint) => generateTaskVariant(blueprint.taskNumber, variant, { ...options, seed, single: true }));
}

function SourceLinks({ task }) {
  const review = useContext(MaturaReviewContext);
  if (review.interactive && !review.reviewAllowed) return null;
  const number = String(task.source.taskNumber);
  const url = kind => {
    const anchor = anchors[kind]?.[number];
    return `/pdfjs/web/viewer.html?file=${encodeURIComponent(`/assets/matura/2026/maj/podstawa/${kind}.pdf`)}#page=${anchor?.page || 1}${anchor ? `&zoom=page-width,0,${anchor.y}` : ""}`;
  };
  return <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginTop: 16 }}>
    <MaturaPdfPreview url={url("arkusz")} title={`Arkusz CKE · maj 2026 · zadanie ${number}`} label="Oryginał zadania · maj 2026" />
    <MaturaPdfPreview url={url("zasady")} title={`Kryteria CKE · maj 2026 · zadanie ${number}`} label="Kryteria CKE · maj 2026" />
  </div>;
}
export function renderTask(task) {
  return <>{getTaskModule(task).renderTask(task)}<SourceLinks task={task} /></>;
}

export function getInteractionSupport(task) {
  const taskModule = getTaskModule(task);
  return {
    renderInput: typeof taskModule.renderInput === "function",
    checkAnswer: typeof taskModule.checkAnswer === "function",
    renderUserAnswer: typeof taskModule.renderUserAnswer === "function",
  };
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return getTaskModule(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return getTaskModule(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return getTaskModule(task).renderAnswer(task);
}

export function renderUserAnswer(userAnswer, task) {
  const module = getTaskModule(task);
  return typeof module.renderUserAnswer === "function"
    ? module.renderUserAnswer(userAnswer, task)
    : null;
}

export function renderExplanation(task) {
  return getTaskModule(task).renderExplanation(task);
}
